import moment from 'moment'
import downloadjs from 'downloadjs'
import { v4 as uuid } from 'uuid'
import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const ChecklistService = {
  getChecklists() {
    return fetchWithToken(`${config().syncService}/checklist`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getChecklistItemById(idChecklist) {
    const filter = JSON.stringify([{ 'field': 'idChecklist', 'operator': '=', 'value': idChecklist }])
    return fetchWithToken(`${config().syncService}/checklistItem?filters=${filter}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getChecklistItemEmployeesById(idChecklistItem) {
    const filter = JSON.stringify([{ 'field': 'idChecklistItem', 'operator': '=', 'value': idChecklistItem }])
    return fetchWithToken(`${config().syncService}/checklistItemEmployees?filters=${filter}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  upsertChecklist(checklist) {
    const parsedChecklist = {
      ...checklist,
      _id: checklist._id || uuid(),
      lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
    }
    return fetchWithToken(`${config().syncService}/checklist`, { method: 'PUT', body: JSON.stringify([parsedChecklist]) })
  },
  upsertChecklistItem(checklistItem) {
    const parsedChecklistItem = {
      ...checklistItem,
      lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
    }
    return fetchWithToken(`${config().syncService}/checklistItem`, { method: 'PUT', body: JSON.stringify([parsedChecklistItem]) })
  },
  upsertChecklistItemEmployees(checklistItemEmployees) {
    const parsedChecklistItemEmployees = {
      ...checklistItemEmployees,
      lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
    }
    return fetchWithToken(`${config().syncService}/checklistItemEmployees`, { method: 'PUT', body: JSON.stringify([parsedChecklistItemEmployees]) })
  },
  downloadChecklist(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/checklist.html`,
      }),
    }).then((response) => response.blob())
      .then((file) => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },
}
